/* eslint-disable */
import dayjs from 'dayjs';
import { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { getCheckEligibility, getMergedProfileInfoDisplay, reCheckEligibilityAction } from "../actions/candidateDataManagementAction";
import label from "../labels/candidatedatamanagement_en.json";
import CandidateProfile from './CandidateProfile';
// import "../../styles/candidate_management.css"
import challanLabels from "../../challanmanagement/Labels/challan_en.json";
// import "../../styles/candidate_management.css"

const ActiveCandidateDetailsTab = (props) => {

    const dispatch = useDispatch();
    const { advertisementDetailsForCandidate, advertisementId, eligibilityResultList,
        selectedProfile, reCheckEligibilityResultList, applicationPostPrefListForReCheckEligibility, eligiblityButtonDisabled } = useSelector((state) => state.candidateDataManagementReducer, shallowEqual)
    useEffect(() => {
        // dispatch(getAdvertisementDetails(props.advt));
        // dispatch(getAdvtDetailsForAdmin(props.advt))
        // eslint-disable-next-line
    }, [])

    const computeIsEligible = (postCriteriaId) => {
        const eligibilityResult = eligibilityResultList?.find(elgbResult => elgbResult.postCriteriaId == postCriteriaId);
        if (!eligibilityResult) {
            return null;
        }
        return eligibilityResult.isEligible;
    }
    const computeIsEligibleMsg = (postCriteriaId) => {
        const eligibilityResult = eligibilityResultList?.find(elgbResult => elgbResult.postCriteriaId == postCriteriaId);
        if (!eligibilityResult) {
            return null;
        }
        return eligibilityResult.message;
    }
    const checkEligibility = () => {
        dispatch(getCheckEligibility(advertisementId, selectedProfile.jwtResponse));
        dispatch(getMergedProfileInfoDisplay(advertisementId, selectedProfile.jwtResponse, 'checkEligibility'));
    }
    const reCheckEligibility = (application) => {
        dispatch(reCheckEligibilityAction(application.id, selectedProfile.jwtResponse))
        dispatch(getMergedProfileInfoDisplay(selectedProfile.personalInfoList && selectedProfile.personalInfoList.profileId, selectedProfile.jwtResponse, 'reCheckEligibility'));
    }
    const getPostName = (postCriteriaId, isDvng) => {
        const examPost = reCheckEligibilityResultList?.examPostList?.find(examPost => examPost.postCriteria.id == postCriteriaId);
        if (!examPost) {
            return `Unknown (${postCriteriaId})`
        }
        return isDvng ? examPost.postCriteria.nameDvng : examPost.postCriteria.name;
    }
    const getElibilityIndicator = (postCriteriaId) => {
        const isEligible = computeIsEligible(postCriteriaId);
        if (isEligible == null) {
            return;
        }
        return isEligible ?
            <span className="text-success">{label.YouAreEligiblePost}</span>
            :
            <span className="text-danger">
                <p className="text-danger">{label.YouAreNotEligiblePost}</p>
            </span>
    }
    const getElibilityIndicatorForError = (postCriteriaId) => {
        const isEligible = computeIsEligible(postCriteriaId);
        const message = computeIsEligibleMsg(postCriteriaId);
        const text = message && message.split("\n")
        if (isEligible == null) {
            return;
        }
        return isEligible ?
            null
            :
            <span className="text-danger">
                {text.map((ele, i) => (
                    <p key={i}>{ele}</p>))}
            </span>
    }
    return (
        <div className="row" style={{ marginRight: "10px", marginLeft: "10px" }}>
            <div className="col-md-12" id="main_block" >
                <div >
                    <div className="row" style={{ marginRight: '0px', marginLeft: '0px' }}>
                        <div className="col-md-8 advertisement_details_firstrow border border-light">
                            <div className="row">
                                <div className="col-md-6 font-weight-bold" >{label.Advertisement_No} {advertisementDetailsForCandidate && advertisementDetailsForCandidate.advertisement ? advertisementDetailsForCandidate.advertisement.advertisementNo : ""}</div>
                                <div className="col-md-6 font-weight-bold " style={{ textAlign: "end" }}></div>
                            </div><hr />
                            <span className="font-weight-bold">  {challanLabels.EXAMINATION}  {advertisementDetailsForCandidate && advertisementDetailsForCandidate.advertisement ? advertisementDetailsForCandidate.advertisement.name : ""}  | {advertisementDetailsForCandidate && advertisementDetailsForCandidate.advertisement ? advertisementDetailsForCandidate.advertisement.nameDvng : ""} </span><br />
                            {/* <span className="font-weight-bold"> {challanLabels.EXAMINATION} {advertisementDetailsForCandidate && advertisementDetailsForCandidate.advertisement && advertisementDetailsForCandidate.advertisement.exam ? advertisementDetailsForCandidate.advertisement.exam.name : ""}  </span><br /><br /> */}
                        </div>
                        <div className="col-md-4 advertisement_details_firstrow border border-light">
                            <label className="font-weight-bold">{label.Start_Date_Application} </label>
                            <span style={{ float: 'right' }}>{advertisementDetailsForCandidate && advertisementDetailsForCandidate.advertisement && advertisementDetailsForCandidate.advertisement.applnStartDate ? dayjs(advertisementDetailsForCandidate.advertisement.applnStartDate).format('DD/MM/YYYY') : ""}
                            </span><br />
                            <label className="font-weight-bold">{label.Last_Date_Application}</label><span style={{ float: 'right' }}>{advertisementDetailsForCandidate && advertisementDetailsForCandidate.advertisement && advertisementDetailsForCandidate.advertisement.applnEndDate ? dayjs(advertisementDetailsForCandidate.advertisement.applnEndDate).format('DD/MM/YYYY') : ""}</span><br />
                            <label className="font-weight-bold">{label.Last_Date_Fees} </label><span style={{ float: 'right' }}>{advertisementDetailsForCandidate && advertisementDetailsForCandidate.advertisement && advertisementDetailsForCandidate.advertisement.challanPaymentEndDate ? dayjs(advertisementDetailsForCandidate.advertisement.challanPaymentEndDate).format('DD/MM/YYYY') : ""}</span>

                        </div>
                    </div>
                    <div className="advertisement_details_Eligibility border border-light">
                        <label className="font-weight-bold">{challanLabels.POSTS}</label>
                        {props.isTab == 1 ?
                            <button type="button" disabled={eligiblityButtonDisabled} className=" btn btn-primary custom_button  btn" style={{ float: 'right' }} onClick={() => { checkEligibility() }} >{label.ELIGIBILITY}</button>
                            :
                            <button type="button" disabled={eligiblityButtonDisabled} className=" btn btn-primary custom_button  btn" style={{ float: 'right' }} onClick={() => { reCheckEligibility(advertisementDetailsForCandidate.application) }} >{label.RE_CHECK_ELIGIBILITY}</button>
                        }
                        <br />
                        <br />
                        <hr />
                        {props.isTab == 1 ?
                            advertisementDetailsForCandidate?.examPostList?.map(examPost =>
                                <div key={examPost.id} className="card" style={{ marginTop: "10px" }}>
                                    <div className="card-header" style={{ paddingBottom: '0px' }}>
                                        <div className="row">
                                            <div className="col-md-9">
                                                <span>{examPost?.postCriteria?.name}</span>
                                            </div>
                                            {eligiblityButtonDisabled ?
                                                <div className="col-md-3" style={{ textAlign: 'end' }}>
                                                    {getElibilityIndicator(examPost?.postCriteria?.id)}
                                                </div> : null
                                            }
                                        </div>
                                    </div>
                                    <div className="card-body" style={{ whiteSpace: 'pre-wrap', paddingBottom: '0px', paddingTop: '9px' }}>
                                        <span>
                                            {examPost?.postCriteria?.description}
                                        </span>
                                        {eligiblityButtonDisabled ?
                                            <span>
                                                {getElibilityIndicatorForError(examPost?.postCriteria?.id)}
                                            </span>
                                            : null}
                                    </div>
                                </div>
                            )
                            :
                            (reCheckEligibilityResultList && reCheckEligibilityResultList.eligibilityResultDtoList != null && applicationPostPrefListForReCheckEligibility && applicationPostPrefListForReCheckEligibility?.length != 0) &&

                            <>
                                {applicationPostPrefListForReCheckEligibility && applicationPostPrefListForReCheckEligibility.map((postPref, index) =>
                                    <div className="card" style={{ marginTop: "10px" }}>
                                        <div className="card-header" >
                                            <div className="row">
                                                <div className="col-md-9">
                                                    <span >{getPostName(postPref.postCriteriaId)}</span> <br />
                                                </div>
                                                {eligiblityButtonDisabled ?
                                                    <div className="col-md-3" style={{ textAlign: 'end' }}>
                                                        {!postPref.isEligible && postPref.message ?
                                                            <span className="text-danger">{label.YouAreNotEligiblePost}</span>
                                                            :
                                                            <span className="text-success">{label.YouAreEligiblePost}</span>
                                                        }
                                                    </div>
                                                    : null}
                                            </div>
                                        </div>
                                        {postPref.message && eligiblityButtonDisabled ?
                                            <div className="card-body" style={{ whiteSpace: 'pre-wrap', paddingTop: '10px' }} >
                                                <span className="text-danger">{postPref.message}</span>
                                            </div>
                                            : null}
                                    </div>
                                )}
                            </>
                        }
                    </div>

                </div>
                {eligiblityButtonDisabled ?
                    <div>
                        <CandidateProfile />
                    </div>
                    : null}
            </div>
        </div>
    )
}

export default ActiveCandidateDetailsTab;